/** venture/HeadCos.tsx — 프로젝트 헤더의 투자법인 줄: 회사마다 소개 FP · 수수료 조건 · 발급 방식 (2026-09-24)
 *  소개자는 조합이 아니라 투자법인 단위다. 조합 헤더에 FP 한 명만 보이던 것을 회사별로 편다. */
import React from 'react';
import { certModesLabel, planModes, projectPlan } from './types';
import type { Project } from './types';
import { TermPills } from './terms';
import { feeOf, feeSummary, certPlanOf, fpLabel } from './coterms';

export default function HeadCos({ p }: { p: Project }) {
  const cos = (p.cos || []).filter((c) => !!(c.name || c.bizno));
  // 투자 처리 방법 — 조합 단위 한 줄 · 늘 보이게(2026-10-16 「수시로 볼 수 있게」 · 2026-10-19 「회사 단위가 아니라 조합 단위로」) · 고치기는 「등록정보」 탭
  const plan0 = projectPlan(p);
  const planLine = <span className={'hc-plan' + (plan0 ? '' : ' none')}><i>투자 처리</i>{plan0 || '미입력 — 「등록정보」 탭에서 적어 주세요'}<TermPills x={p} showUnset /></span>;
  if (!cos.length) return <div className="m">투자법인<b>(미입력)</b>{planLine}</div>;
  return (
    <div className="m headcos">투자법인 · 소개자(FP) · 수수료
      {planLine}
      <div className="hc-list">
        {cos.map((c, i) => {
          const fp = fpLabel(c);
          const plan = certPlanOf(c);
          return (
            <div className="hc" key={i}>
              <b>{c.name || c.bizno}</b>
              <span className="hc-fp">{fp ? '소개 ' + fp : <em>FP 미입력</em>}</span>
              <span className="hc-fee">{feeSummary(feeOf(c))}</span>
              <span className={'pill ' + (planModes(plan).length ? 'p-blue' : 'p-gray')} title="투자확인서 발급 방식">{planModes(plan).length ? certModesLabel(planModes(plan)) : '발급 방식 미선택'}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
